// src/ProjectIntro.js

import React, { useRef } from 'react';
import { fileToDataURL, cropAndResizeDataURL } from './utils/imageUtils';

const assessors    = ['Jon McNatt','Mike McNatt','Thomas Carroll'];
const projectTypes = ['Assessment','Clearance','Addendum'];

export default function ProjectIntro({ data, onChange }) {
  const fileInputRef = useRef(null);
  const { assessor, projectName, projectType, dateTime, propertyPhoto } = data;
  const change = (field, val) => onChange(field, val);

  const handlePhotoFile = async file => {
    const rawUrl   = await fileToDataURL(file);
    const thumbUrl = await cropAndResizeDataURL(rawUrl, 280);
    change('propertyPhoto', thumbUrl);
  };

  return (
    <div className="border p-4 mb-6 rounded-lg">
      <h2 className="text-xl font-semibold mb-4">Project Information</h2>

      {/* Assessor & Name */}
      <div className="flex gap-4 mb-4">
        <select
          className="flex-1 border rounded px-2 py-1"
          value={assessor}
          onChange={e => change('assessor', e.target.value)}
        >
          <option value="">Select Assessor…</option>
          {assessors.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        <input
          type="text"
          className="flex-1 border rounded px-2 py-1"
          placeholder="Project Name"
          value={projectName}
          onChange={e => change('projectName', e.target.value)}
        />
      </div>

      {/* Type & Date */}
      <div className="flex gap-4 mb-4">
        <select
          className="flex-1 border rounded px-2 py-1"
          value={projectType}
          onChange={e => change('projectType', e.target.value)}
        >
          <option value="">Select Type…</option>
          {projectTypes.map(pt => <option key={pt} value={pt}>{pt}</option>)}
        </select>
        <input
          type="date"
          className="flex-1 border rounded px-2 py-1"
          value={dateTime.substring(0,10)}
          onChange={e => change('dateTime', e.target.value)}
        />
      </div>

      {/* Property Photo */}
      <div className="mb-4">
        <label className="block mb-1 font-medium">Property Photo:</label>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={e =>
            e.target.files[0] && handlePhotoFile(e.target.files[0])
          }
        />
        <button
          className="bg-green-600 text-white px-4 py-2 rounded"
          onClick={() => fileInputRef.current.click()}
        >
          Upload Photo
        </button>
        {propertyPhoto && (
          <div className="mt-2 flex items-center gap-4">
            <img
              src={propertyPhoto}
              alt="Property"
              className="w-24 h-24 object-cover rounded"
            />
            <button
              className="bg-red-500 text-white px-2 py-1 rounded"
              onClick={() => change('propertyPhoto', null)}
            >
              Delete
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
